// Espelho da lista de permissão do backend (`backend/src/config/upload.ts`,
// constante `allowedExtensions`). O backend é a autoridade: ele recusa o que
// não estiver na lista dele, e esta cópia existe só para o navegador avisar
// ANTES de subir o arquivo inteiro — quem anexa um .exe de 20 MB não deveria
// esperar o upload terminar para descobrir que não vale.
//
// Ao mexer na lista de lá, mexa aqui também.
export const EXTENSOES_ACEITAS = [
	// imagem — sem .svg, que é XML com script dentro
	".jpg",
	".jpeg",
	".png",
	".gif",
	".webp",
	".bmp",
	".tiff",
	".heic",
	".heif",
	// áudio
	".mp3",
	".ogg",
	".oga",
	".opus",
	".wav",
	".m4a",
	".aac",
	".amr",
	".flac",
	// vídeo
	".mp4",
	".3gp",
	".mov",
	".avi",
	".mkv",
	".webm",
	// documentos
	".pdf",
	".doc",
	".docx",
	".xls",
	".xlsx",
	".ppt",
	".pptx",
	".odt",
	".ods",
	".odp",
	".rtf",
	".txt",
	".csv",
	".md",
	".json",
	".xml",
	".epub",
	// compactados
	".zip",
	".rar",
	".7z",
	".gz",
	".tgz"
];

// Valor do atributo `accept` do <input type="file">. Filtra o que aparece na
// janela do sistema; não substitui a validação, que qualquer um contorna
// escolhendo "todos os arquivos".
export const ACCEPT_UPLOAD = EXTENSOES_ACEITAS.join(",");

export const TAMANHO_MAXIMO_MB = 25;
export const TAMANHO_MAXIMO_BYTES = TAMANHO_MAXIMO_MB * 1024 * 1024;

export const extensaoDoArquivo = (nome = "") => {
	const ponto = nome.lastIndexOf(".");
	return ponto === -1 ? "" : nome.slice(ponto).toLowerCase();
};

// Devolve a mensagem do problema, ou "" quando o arquivo passa. Mensagem, e
// não booleano, porque quem recusa precisa dizer o motivo.
export const problemaDoArquivo = (arquivo) => {
	const ext = extensaoDoArquivo(arquivo?.name);

	if (!EXTENSOES_ACEITAS.includes(ext)) {
		return ext
			? `arquivos ${ext} não são aceitos`
			: "arquivos sem extensão não são aceitos";
	}

	if (arquivo.size > TAMANHO_MAXIMO_BYTES) {
		const mb = (arquivo.size / 1024 / 1024).toFixed(1);
		return `tem ${mb} MB e o limite é ${TAMANHO_MAXIMO_MB} MB`;
	}

	return "";
};
